import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ClientAvatar from './ClientAvatar';

const ClientBadge = ({ clientName, avatarSize = 16, sx = {} }) => {
  if (!clientName) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px', mt: '3px', ...sx }}>
      <ClientAvatar name={clientName} size={avatarSize} sx={{ flexShrink: 0, fontSize: Math.max(8, Math.round(avatarSize * 0.5)) }} />
      <Typography sx={{ fontSize: 12, color: 'text.disabled', lineHeight: 1 }}>
        {clientName}
      </Typography>
    </Box>
  );
};

ClientBadge.propTypes = {
  clientName: PropTypes.string,
  avatarSize: PropTypes.number,
  sx: PropTypes.object,
};

export default ClientBadge;
